import './license-management.page.css';

// Slice
import { selectOrgLevel } from '../../../stores/slice/pageContext';

// Const
import Nuclias from "../../../const/nuclias";
import { userPrivilege } from 'const/nuclias/user';

// UI component
import Breadcrumbs from '../../../components/Breadcrumb';
import MessageBoxGroup from "../../../components/MessageBoxGroup";
import Tab from '../../../components/Tab';

// Sub pages
import Overview from './Overview';
import Devices from './Devices';
import Licenses from './Licenses';
import CoTermination from './CoTermination';
import LicenseLog from './LicenseLog';

import { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom"; // get value from router loader.
import { isNil, cloneDeep, filter } from "lodash";

// Default value
const defaultMessages = {
  success: null,
  error: null,
  warning: null,
};

const defaultTabList = [
  { id: 1, breadCrumbLabel: 'Overview', label: 'f7f09cf0f2', value: 'overview', isActive: true },
  { id: 2, breadCrumbLabel: 'Inventory', label: '3096b6ebc0', value: 'devices', isActive: false },
  { id: 3, breadCrumbLabel: 'License management', label: 'f6aca2dcfe', value: 'licenses', isActive: false },
  { id: 4, breadCrumbLabel: 'License logs', label: '2e1ce845da', value: 'license-logs', isActive: false }
];

const defaultOrgTabList = [
  { id: 1, breadCrumbLabel: 'Overview', label: 'f7f09cf0f2', value: 'overview', isActive: true },
  { id: 2, breadCrumbLabel: 'Inventory', label: '3096b6ebc0', value: 'devices', isActive: false },
  { id: 3, breadCrumbLabel: 'License management', label: 'f6aca2dcfe', value: 'licenses', isActive: false },
  { id: 4, breadCrumbLabel: 'License co-termination', label: '21c1f8a141', value: 'co-termination', isActive: false },
  { id: 5, breadCrumbLabel: 'License logs', label: '2e1ce845da', value: 'license-logs', isActive: false }
];

const defaultPathList = [
  { label: 'Settings', isLink: false },
  { label: defaultTabList[0].label, isLink: false }
];

const LicenseManagement = (props) => {
  const location = useLocation();
  let defaultTab = location?.state?.tab;

  const user = useSelector(state => state.user.user);
  const [messages, setMessages] = useState({ ...defaultMessages });
  const [isChanginOrg, setIsChanginOrg] = useState(false);
  const isOrgLevel = useSelector(selectOrgLevel) === Nuclias.organizationType.org ? true : false;
  const privilege = user.privilege === userPrivilege.manager ? true : false;
  const { reloadStatus } = useSelector(state => state.fetchStatus);
  const { selectedOrg } = useSelector(state => state.pageContext);

  const [tabList, setTabList] = useState(null);
  const [pathList, setPathList] = useState([...defaultPathList]);
  const [filteredData, setFilteredData] = useState({ who: null, type: null });

  const filterData = (who, type) => {
    const updatedFilteredData = { who, type };
    setFilteredData(updatedFilteredData);
  };

  useEffect(() => {
    const tabList = cloneDeep(defaultTabList);
    const orgTabList = cloneDeep(defaultOrgTabList);

    (isOrgLevel && privilege) ? setTabList(orgTabList) : setTabList(tabList);
  }, [isOrgLevel, selectedOrg, privilege]);

  const resetMessage = () => {
    setMessages({ ...defaultMessages });
  };

  const changeTab = selectedTab => {
    // Clean filtered data when back to overview tab
    selectedTab.value === tabList[0].value && setFilteredData({ who: null, type: null });

    defaultTab = null;
    const newTabList = [...tabList];
    const index = newTabList.findIndex(tab => tab.id === selectedTab.id);

    resetMessage();
    newTabList.map(tab => tab.isActive = false);
    newTabList[index].isActive = true;
    setTabList(newTabList);

    const newPathList = [...pathList];
    newPathList[1].label = selectedTab.breadCrumbLabel;
    setPathList(newPathList);
  };

  useEffect(() => {
    if (tabList && defaultTab) {
      const index = tabList.findIndex(tab => tab.value.toLocaleLowerCase() === defaultTab.toLocaleLowerCase());
      if (index > -1) {
        changeTab(tabList[index]);
      }
    }
  }, [location]);

  useEffect(() => {
    resetMessage();
    if (reloadStatus.data?.reloadState === Nuclias.reloadState.doing) {
      setIsChanginOrg(true);
    } else {
      setIsChanginOrg(false);
    }
  }, [reloadStatus]);

  return (
    <>
      <Breadcrumbs pathList={pathList} />
      <MessageBoxGroup
        containerMode={true}
        messages={messages}
        ErrorMessagesType='es'
        SuccessMessagesType='i18n'
        WarningMessagesType='i18n'
        onClose={(value) => setMessages({ ...defaultMessages, [value]: null })}
      />

      <Tab tabList={tabList} changeTab={changeTab} />
      {!isChanginOrg && (
        <>
          {tabList && tabList[0].isActive && <Overview
            tabList={tabList}
            changeTab={changeTab}
            filterData={filterData}
            isOrgLevel={isOrgLevel}
            messages={messages}
            setMessages={setMessages}
          />}
          {tabList && tabList[1].isActive && <Devices{...{ filteredData, filterData, setMessages }} />}
          {tabList && tabList[2].isActive && <Licenses {...{ filteredData, filterData, setMessages }} />}
          {tabList && !isOrgLevel && tabList[3].isActive && <LicenseLog
            isOrgLevel={isOrgLevel}
            messages={messages}
            setMessages={setMessages}
          />}
          {tabList && isOrgLevel && tabList[3].isActive && <CoTermination
            messages={messages}
            setMessages={setMessages}
          />}
          {tabList && tabList[4] && isOrgLevel && tabList[4].isActive && <LicenseLog
            isOrgLevel={isOrgLevel}
            messages={messages}
            setMessages={setMessages}
          />}
        </>
      )}
    </>
  );
};

export default LicenseManagement;